interface IconProps {
    size?: number;
}

export default function EntraIdIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 23 23" fill="none">
            <rect x="1" y="1" width="10" height="10" fill="#F25022" />
            <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
            <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
            <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
        </svg>
    );
}
